var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}import moment from'moment';

var ShortApiTimeFormat='HH:mm:ss';
var ApiTimeFormat='HH:mm:ss.SSS';
var ApiDateFormat='MM/DD/YYYY';
var PageDateFormat='DD-MMM-YYYY';
var PageTimeFormat='h:mm A';
var ISODateFormat='YYYY-MM-DD';var

ServicesFormatter=function(){function ServicesFormatter(){_classCallCheck(this,ServicesFormatter);}_createClass(ServicesFormatter,null,[{key:'formatTime',value:function formatTime(
























momentObj){
return momentObj.format(PageTimeFormat);
}},{key:'formatDateForApi',value:function formatDateForApi(

momentObj){
return momentObj.format(ApiDateFormat);
}},{key:'formatDateForISO',value:function formatDateForISO(

momentObj){
return momentObj.format(ISODateFormat);
}},{key:'formatTimeForApi',value:function formatTimeForApi(

momentObj){
return momentObj.format(ApiTimeFormat);
}},{key:'createMomentFromApiTime',value:function createMomentFromApiTime(

time){
if(!time){
return null;
}

return moment(time,ApiTimeFormat);
}},{key:'createMomentFromApiDate',value:function createMomentFromApiDate(

date){
if(!date){
return null;
}

return moment(date,ISODateFormat);
}},{key:'ApiTimeFormat',get:function get(){return ApiTimeFormat;}},{key:'ShortApiTimeFormat',get:function get(){return ShortApiTimeFormat;}},{key:'ISODateFormat',get:function get(){return ISODateFormat;}},{key:'ApiDateFormat',get:function get(){return ApiDateFormat;}},{key:'PageTimeFormat',get:function get(){return PageTimeFormat;}},{key:'PageDateFormat',get:function get(){return PageDateFormat;}}]);return ServicesFormatter;}();


export default ServicesFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/services/Services.formatter.js
// module id = 78
// module chunks = 0